import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";

class DetailDeduction {
  detailKasbon(id) {
    const endPoint = `/worker/salary/deduction/kasbon/${id}`;
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }
    detailInstallment(id) {
    const endPoint = `/worker/salary/deduction/cicilan/${id}`;
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.get(url, headersTokenConfig);
  }
}

export default new DetailDeduction();
